import { NgModule } from '@angular/core';

import {CalendarModule} from 'primeng/primeng';

import { DocumentListComponent } from './document-list/document-list.component';
import { routedComponents, DocumentRoutingModule } from './document-routing.module';
import { SharedModule } from '../shared/shared.module';
import { DocumentService } from './shared';

@NgModule({
  imports: [SharedModule, DocumentRoutingModule, CalendarModule],
  declarations: [routedComponents],
  providers: [DocumentService],
})

export class DocumentsModule { }



// WEBPACK FOOTER //
// ./src/app/documents/documents.module.ts